export default "__VITE_ASSET__DCxrQEo9__"